export default __webpack_public_path__ + "static/media/express-inabit.045db159.svg";